import request from '@/utils/request'

/** PC 运营端/物业端：查询业主正式 ISUP 人脸及逐设备同步状态 */
export function queryPcOwnerFaceDetail(params) {
  return request({
    url: '/isup.queryPcOwnerFaceDetail',
    method: 'get',
    params
  }).then(response => {
    const res = response.data
    if (res.code !== 0) {
      throw new Error(res.msg || '获取门禁人脸信息失败')
    }
    return res.data || {}
  })
}

/** PC 业主列表：按同一小区的当前页人员批量查询正式 ISUP 人脸 */
export function queryPcOwnerFaceSources(params) {
  return queryPcOwnerFaceDetail(params)
}
